import React from "react";
import { useAuth } from "../auth/useAuth";
import { useUiPreferences } from "../prefs/useUiPreferences";
import { DEFAULT_UNITS_LOCALE } from "./format";
import { getSystemTimeZone } from "./timezone";
import type { UnitsSettings } from "./units";
import { loadUnits } from "./unitsStorage";

export function normalizeUnits(units?: UnitsSettings | null): UnitsSettings {
  const locale = (units?.locale || "").trim() || DEFAULT_UNITS_LOCALE;
  return {
    ...units,
    locale,
    numberLocale: (units?.numberLocale || "").trim() || locale,
    // Ohne eingestellte Zeitzone gilt die des Geräts, keine feste Anzeigezone.
    timeZone: (units?.timeZone || "").trim() || getSystemTimeZone(),
    currency: (units?.currency || "").trim() || "EUR"
  };
}

export function useEffectiveUnits(): UnitsSettings {
  const auth = useAuth();
  const ui = useUiPreferences();

  return React.useMemo(() => {
    const localMirror = loadUnits(auth.info?.accountId);
    return normalizeUnits({ ...localMirror, ...(ui.prefs.units ?? {}) });
  }, [auth.info?.accountId, ui.prefs.units]);
}
